import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: `calc(100% - ${theme.spacing(1.25)}px)`,
      maxWidth: `calc(100% - ${theme.spacing(0.75)}px)`,
      marginLeft: theme.spacing(1),
      display: 'flex',
      alignItems: 'center',
      padding: `${theme.spacing(1.5)}px 0`,
      position: 'absolute',
      top: 0,
      left: 0,
      userSelect: 'none',
    },
    grid: {
      display: 'grid',
      width: '100%',
    },
    fixedHeader: {
      position: 'fixed',
      backgroundColor: theme.palette.common.white,
      zIndex: 100,
      marginLeft: theme.spacing(2),
    },
    aggregateFixedHeader: {
      height: 56,
      width: 40,
      backgroundColor: theme.palette.common.white,
      position: 'absolute',
      right: -10,
      top: 0,
      zIndex: 99,
    },
  }),
);
